import { faArrowRight, faTrash, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';
import { Badge } from 'react-bootstrap';
import { Condition } from 'reducers/nodesReducer';

type TConditionRow = {
  condition: Condition;
  authorized: boolean;
  onEdit: () => void;
  onDelete: () => void;
};

export default function ConditionRow({ condition, authorized, onEdit, onDelete }: TConditionRow): React.ReactElement {
  const property = useMemo(
    () => condition.property.charAt(0) + condition.property.slice(1).toLowerCase().replace(/_/g, ' '),
    [condition]
  );
  const criteria = useMemo(() => condition.criteria.charAt(0) + condition.criteria.slice(1).toLowerCase(), [condition]);

  return (
    <tr>
      <td title={condition.sourceNodeAeTitle}>{condition.sourceNodeAeTitle}</td>
      <td>
        <FontAwesomeIcon icon={faArrowRight} />
      </td>
      <td title={condition.destinationNodeAeTitle}>{condition.destinationNodeAeTitle}</td>
      <td title={property}>{property}</td>
      <td title={criteria}>{criteria}</td>
      <td title={condition.refValue}>{condition.refValue}</td>
      <td title={condition.pk.toString()}>
        {condition.enabled ? <Badge variant="success">Enabled</Badge> : <Badge variant="danger">Disabled</Badge>}
      </td>
      <td>
        <div style={{ width: '100%', textAlign: 'right', overflow: 'visible' }}>
          {authorized && <FontAwesomeIcon icon={faWrench} className="clickable-icon" onClick={onEdit} />}
          {authorized && <FontAwesomeIcon icon={faTrash} className="clickable-icon" onClick={onDelete} />}
        </div>
      </td>
    </tr>
  );
}
